import react from "react";

import ErnstingFamily1 from "../images/commercials/ErnstingFamily/ERNSTINGFAMILY_000 Large.jpeg";
import ErnstingFamily2 from "../images/commercials/ErnstingFamily/ERNSTINGFAMILY_001 Large.jpeg";
import ErnstingFamily3 from "../images/commercials/ErnstingFamily/ERNSTINGFAMILY_002 Large.jpeg";
import ErnstingFamily4 from "../images/commercials/ErnstingFamily/ERNSTINGFAMILY_003 Large.jpeg";
import ErnstingFamily5 from "../images/commercials/ErnstingFamily/ERNSTINGFAMILY_004 Large.jpeg";
import ErnstingFamily6 from "../images/commercials/ErnstingFamily/ERNSTINGFAMILY_005 Large.jpeg";
import ErnstingFamily7 from "../images/commercials/ErnstingFamily/ERNSTINGFAMILY_006 Large.jpeg";
import ErnstingFamily8 from "../images/commercials/ErnstingFamily/ERNSTINGFAMILY_007 Large.jpeg";
import ErnstingFamily9 from "../images/commercials/ErnstingFamily/ERNSTINGFAMILY_008 Large.jpeg";
import ErnstingFamily10 from "../images/commercials/ErnstingFamily/ERNSTINGFAMILY_009 Large.jpeg";
import ErnstingFamily11 from "../images/commercials/ErnstingFamily/ERNSTINGFAMILY_010 Large.jpeg";
import ErnstingFamily12 from "../images/commercials/ErnstingFamily/ERNSTINGFAMILY_011 Large.jpeg";
import ErnstingFamily13 from "../images/commercials/ErnstingFamily/ERNSTINGFAMILY_012 Large.jpeg";
import ErnstingFamily14 from "../images/commercials/ErnstingFamily/ERNSTINGFAMILY_013 Large.jpeg";

const ErnstingFamily = () => {
    return (

        <div className="picture-gallery">
            <div className="photo-column">
                <div className="single portrait">
                    <img src={ErnstingFamily1} alt="Ernsting Family Commercial Photography - Image 1"/>
                </div>
                <div className="single portrait">
                    <img src={ErnstingFamily2} alt="Ernsting Family Commercial Photography - Image 2"/>
                </div>
                <div className="single portrait">
                    <img src={ErnstingFamily3} alt="Ernsting Family Commercial Photography - Image 3"/>
                </div>
                <div className="single portrait">
                    <img src={ErnstingFamily4} alt="Ernsting Family Commercial Photography - Image 4"/>
                </div>
                <div className="single portrait">
                    <img src={ErnstingFamily6} alt="Ernsting Family Commercial Photography - Image 6"/>
                </div>
                <div className="single portrait">
                    <img src={ErnstingFamily5} alt="Ernsting Family Commercial Photography - Image 5"/>
                </div>
                <div className="single portrait">
                    <img src={ErnstingFamily7} alt="Ernsting Family Commercial Photography - Image 7"/>
                </div>
                <div className="single portrait">
                    <img src={ErnstingFamily8} alt="Ernsting Family Commercial Photography - Image 8"/>
                </div>
                <div className="single portrait">
                    <img src={ErnstingFamily9} alt="Ernsting Family Commercial Photography - Image 9"/>
                </div>
                <div className="single portrait">
                    <img src={ErnstingFamily10} alt="Ernsting Family Commercial Photography - Image 10"/>
                </div>
                <div className="single portrait">
                    <img src={ErnstingFamily11} alt="Ernsting Family Commercial Photography - Image 11"/>
                </div>
                <div className="single portrait">
                    <img src={ErnstingFamily12} alt="Ernsting Family Commercial Photography - Image 12"/>
                </div>
                <div className="single portrait">
                    <img src={ErnstingFamily13} alt="Ernsting Family Commercial Photography - Image 13"/>
                </div>
                <div className="single portrait">
                    <img src={ErnstingFamily14} alt="Ernsting Family Commercial Photography - Image 14"/>
                </div>
            </div>
        </div>
    );
}

export default ErnstingFamily;